import { nyExp } from "srp/scripts/utils";

const FACET_HOME_FEATURES_MAPPING = {
  'view': 'Views',
  'waterfront': 'Waterfront',
  'golf_course_view': 'Golf Course',
  'swimming_pool': 'Pool',
  'hardwood_floors': 'Hardwood Floors',
  'basement': 'Basement',
  'recreation_facilities': 'Gym/Rec. Facility',
  'washer_dryer': 'In Unit Washer/Dryer',
  'fireplace': 'Fireplace',
  'energy_efficient_home': 'Energy Efficient',
  'disability_features': 'Disability Features',
  'dining_room': 'Dining Room',
  'laundry_room': 'Laundry',
  'family_room': 'Family Room',
  'den_or_office': 'Den/Office',
  'game_room': 'Game Room',
  'central_air': 'Central Air',
  'central_heat': 'Central Heat',
  'forced_air': 'Forced Air',
  'single_story': 'Single Story',
  'two_or_more_stories': 'Multi Stories',
  'corner_lot': 'Corner Lot',
  'water_view': 'Water View',
  'golf_course_lot_or_frontage': 'Golf Course Lot/Frontage',
  'cul_de_sac': 'Cul-De-Sac',
  'hill_or_mountain_view': 'Hill/Mountain',
  'ocean_view': 'Ocean View',
  'city_view': 'City View',
  'lake_view': 'Lake View',
  'river_view': 'River View',
  'community_security_features': 'Comm Security Features',
  'community_swimming_pool': 'Comm Swimming Pool(s)',
  'community_boat_facilities': 'Comm Boat Facilities',
  'community_clubhouse': 'Comm Clubhouse(s)',
  'community_horse_facilities': 'Comm Horse Facilities',
  'community_tennis_court': 'Comm Tennis Court(s)',
  'community_park': 'Comm Park(s)',
  'community_golf': 'Comm Golf',
  'senior_community': 'Senior Comm',
  'community_spa_or_hot_tub': 'Comm Spa/Hot Tub(s)',
  'rv_or_boat_parking': 'RV/Boat Parking',
  'horse_facilities': 'Horse Facilities',
  'tennis_court': 'Tennis Courts',
  'spa_or_hot_tub': 'Spa/Hot Tub',
  'garage_1_or_more': '1+ Car Garage',
  'garage_2_or_more': '2+ Car Garage',
  'garage_3_or_more': '3+ Car Garage',
  'carport': 'Carport',
  'community_doorman': 'Doorman',
  'pets_allowed': 'Pets Allowed',
  'community_elevator': 'Elevator',
  'community_outdoor_space': 'Outdoor Space',
  'furnished': 'Furnished',
  'dishwasher': 'Dishwasher',
  'community_no_fee': 'No Fee'
};

// For NY Experience Pill would display Parking / Garage instead of '1+ Car Garage'
// And Laundry would display Laundry Room
if( nyExp ) {
  Object.assign(FACET_HOME_FEATURES_MAPPING, { 'garage_1_or_more': 'Parking / Garage' }, { 'laundry_room': 'Laundry Room' });
}

export {
  FACET_HOME_FEATURES_MAPPING
};



// WEBPACK FOOTER //
// ./srp/constants/facets-features.js